import { actionTypes } from 'redux-query';

import urls from 'constants/urls';

/**
 * Если передан meta.errorCallback, он будет вызван.
 *
 * @return {void}
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default () =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  (next) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  (action) => {
    if (action.type === actionTypes.REQUEST_FAILURE) {
      // NOTE: 403 (Forbidden) is intentionally NOT treated as a logout trigger anymore (GB42-3427 AC-09):
      // it means the authenticated user lacks permission for this action, not that the session expired.
      // Only 401 (Unauthorized) still forces a re-login.
      if (action.status === 401) {
        localStorage.clear();
        window.location.href = `${window.location.origin}${urls.getAuth()}`;

        return;
      }
      const { errorCallback } = action.meta;

      if (errorCallback) {
        errorCallback({
          body: action.responseBody,
          text: action.responseText,
          status: action.status,
          unauthorized: action.status === 401,
        });
      }
    }

    return next(action);
  };
